import { faHtml5, faWordpress, faJsSquare, faReact, faCss3Alt } from '@fortawesome/free-brands-svg-icons';
import * as React from 'react';
export default {
  faHtml5,
  faWordpress,
  faJsSquare,
  faReact,
  faCss3Alt,
  React
};